import { KeyboardEvent, useCallback } from 'react';

export const useEnterPressed = <T>(callback: () => void) => {
  return useCallback(
    (e: KeyboardEvent<T>) => {
      if (e.key === 'Enter') return callback();
    },
    [callback]
  );
};
